import classNames from 'classnames';
import { FC, memo, ReactElement } from 'react';
import Spinner from '../Controls/Spinner/Spinner';
import theme from '~/constants/styles';
import './style.scss';

interface IProps {
  visible?: boolean;
  refreshing?: boolean;
  className?: string;
  spinnerClassName?: string;
  spinnerSize?: number;
  spinnerColor?: string;
}

const LoadingOverlay: FC<IProps> = (props: IProps): ReactElement | null => {
  if (!props.visible) return null;

  return (
    <div className={classNames('loading-overlay', props.className, { 'loading-overlay_refreshing': props.refreshing })}>
      <Spinner
        size={props.spinnerSize || 45}
        color={props.spinnerColor || theme.colors.mainblue}
        className={classNames('loading-overlay__spinner', props.spinnerClassName)}
      />
    </div>
  );
};

export default memo(LoadingOverlay);
